import dagre from 'dagre';

const getNodeSize = node => ({
  width: node.measured?.width ?? node.width ?? 150,
  height: node.measured?.height ?? node.height ?? 50,
});

const getLayoutedElements = (nodes, edges = [], direction = 'LR') => {
  const isHorizontal = direction === 'LR';
  const dagreGraph = new dagre.graphlib.Graph();
  dagreGraph.setDefaultEdgeLabel(() => ({}));
  dagreGraph.setGraph({ rankdir: direction, ranksep: 100 });

  nodes.forEach(node => {
    const { width, height } = getNodeSize(node);
    dagreGraph.setNode(node.id, { width, height });
  });
  edges.forEach(edge => {
    dagreGraph.setEdge(edge.source, edge.target);
  });

  dagre.layout(dagreGraph);

  const layoutedNodes = nodes.map(nodeIn => {
    const { id, targetPosition, sourcePosition } = nodeIn;
    const { width, height } = getNodeSize(nodeIn);
    const nodeWithPosition = dagreGraph.node(id);
    const position = {
      x: nodeWithPosition.x - width / 2 + Math.random() / 1000,
      y: nodeWithPosition.y - height / 2,
    };

    return {
      ...nodeIn,
      targetPosition: targetPosition ?? (isHorizontal ? 'left' : 'top'),
      sourcePosition: sourcePosition ?? (isHorizontal ? 'right' : 'bottom'),
      position,
    };
  });

  return { nodes: layoutedNodes, edges };
};

export default getLayoutedElements;
